import UILabeledInput from '../../../../../../../components/UI/UILabeledInput';
import UIIconButton from '../../../../../../../components/UI/UIIconButton';
import { PlusIcon } from '../../../../../../../assets/icons';
import React, { useState } from 'react';
import UIOverlayCard from '../../../../../../../components/UI/UIOverlayCard';
import { useDispatch, useSelector } from 'react-redux';
import { getSelectedRegionSelector } from '../../../../../../../redux/selectors/CurrentUserSelectors';
import UIModal from '../../../../../../../components/UI/UIModal';
import { UI_LABELED_INPUT_NUMBER_TYPE } from '../../../../../../../components/UI/UILabeledInput/config';
import { toast } from 'react-toastify';
import { setSelectedRegion } from '../../../../../../../redux/store/user/actions';
import { useMutation } from '@apollo/react-hooks';
import * as strings from './strings';
import { UPDATE_REGION_ZIPS } from './queries';
import './styles';
import { UI_ICON_BUTTON_FILL_TYPE } from '../../../../../../../components/UI/UIIconButton/config';

export default function RegionZipModal({ hideModal }) {
	const dispatch = useDispatch();

	const [zipCode, setZipCode] = useState<string>('');
	const [isLoading, setIsLoading] = useState<boolean>(false);
	const [searchFilter, setSearchFilter] = useState('');
	const [showAddZipModal, setShowAddZipModal] = useState<boolean>(false);
	const selectedRegion = useSelector(getSelectedRegionSelector);

	const [updateRegionForZips] = useMutation(UPDATE_REGION_ZIPS);

	let zipCodes: string[] = selectedRegion['zipCodes'];
	const filteredZipCodes = searchFilter ? zipCodes.filter((zipCode) => zipCode.startsWith(searchFilter)) : zipCodes;

	const addZipCode = async () => {
		if (!isLoading) {
			setIsLoading(true);
		}
		if (zipCode.trim().length !== 5) {
			toast.info(strings.addValidZipError);
			return;
		}
		if (!zipCodes) {
			zipCodes = [];
		}
		zipCodes.push(zipCode);
		const response = await updateRegionForZips({ variables: { id: selectedRegion.id, zipCodes } });

		const { updateRegion } = response['data'];
		if (updateRegion) {
			let region: RegionType = Object.assign({}, selectedRegion);
			region.zipCodes = zipCodes;
			dispatch(setSelectedRegion(region));
			setShowAddZipModal(false);
			setIsLoading(false);
			toast.success(strings.successAddingZip(zipCode));
		} else {
			toast.error(strings.errorAddingZip);
		}
	};

	const removeZipCode = async (zipCode) => {
		let zipCodes = selectedRegion['zipCodes'].filter((e) => e !== zipCode);
		const response = await updateRegionForZips({ variables: { id: selectedRegion.id, zipCodes } });
		const { updateRegion } = response['data'];
		if (updateRegion) {
			let region = Object.assign({}, selectedRegion);
			region.zipCodes = updateRegion.zipCodes;
			dispatch(setSelectedRegion(region));
			toast.success(strings.removedZip(zipCode));
		} else {
			toast.error(strings.errorRemovingZip);
		}
	};

	const renderAddZipModal = () => {
		const hideModal = () => {
			setShowAddZipModal(false);
		};

		return (
			<UIModal condition={showAddZipModal}>
				<UIOverlayCard hideModal={hideModal} title={strings.addZipTitle} description={strings.addZipDescription(selectedRegion.name)}>
					<UILabeledInput
						noFormatting
						hideLabel
						type={UI_LABELED_INPUT_NUMBER_TYPE}
						onChangeValue={(value) => setZipCode(value)}
						value={zipCode}
						placeholder={strings.zipCodePlaceholder}
					/>
					<UIIconButton
						dark
						className='zipButton__add'
						type={UI_ICON_BUTTON_FILL_TYPE}
						isLoading={isLoading}
						text={strings.addZipButton}
						onClick={addZipCode}
					/>
				</UIOverlayCard>
			</UIModal>
		);
	};

	return (
		<UIOverlayCard hideModal={hideModal} title={strings.overlayAddZipTitle}>
			<UILabeledInput
				containerClassName='zipFilter'
				placeholder={strings.searchZipsPlaceholder}
				className='zipButton__add'
				onChangeValue={(searchFilter) => setSearchFilter(searchFilter)}
				value={searchFilter}
			/>
			<div className='zipList'>
				{filteredZipCodes &&
					filteredZipCodes
						.sort((a: any, b: any) => a - b)
						.map((zipCode) => (
							<p className='zipList__text' onClick={() => removeZipCode(zipCode)} key={zipCode}>
								{zipCode}
							</p>
						))}
			</div>
			<UIIconButton className='zipButton' icon={PlusIcon.darkGrey} type={UI_ICON_BUTTON_FILL_TYPE} onClick={() => setShowAddZipModal(true)} />
			{renderAddZipModal()}
		</UIOverlayCard>
	);
}
